const endpoints = {
    users:'/administracion/user',
    permissions:'/administracion/permissions',
    subdirecciones:'/administracion/subdirecciones'
    // exportTeacherList:'/user/teachers/export'
}
export {endpoints}